/*eslint-disable*/
const NumericFilterOperators = [
    {
        label: "=",
        title: "Equal",
        value: "equals",
        filter: (currentValue, comparisonValue) => currentValue === comparisonValue
    },
    {
        label: ">",
        title: "Greater Than",
        value: "greaterThan",
        filter: (currentValue, comparisonValue) => currentValue > comparisonValue
    },
    {
        label: "<",
        title: "Less Than",
        value: "lessThan",
        filter: (currentValue, comparisonValue) => currentValue < comparisonValue
    },
    {
        label: "<>",
        title: "Between",
        value: "between",
        needsRange: true,
        filter: (currentValue, startRange, endRange) => currentValue >= startRange && currentValue <= endRange
    }
];

export default NumericFilterOperators;